import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { SummaryRunAsUserSettings } from '../../../model';

// SET_SHOW_DIALOG
export const SET_SHOW_DIALOG = 'state.actions.run-as-user.SET_SHOW_DIALOG' as const;

export type SetShowDialogAction = {
	type: typeof SET_SHOW_DIALOG;
	payload: {
		show: boolean;
	};
};

export const setShowDialog = (show: boolean): SetShowDialogAction => ({
	type: SET_SHOW_DIALOG,
	payload: {
		show,
	},
});

// SET_SHOW_MISCONFIGURED_DIALOG
export const SET_SHOW_MISCONFIGURED_DIALOG =
	'state.actions.run-as-user.SET_SHOW_MISCONFIGURED_DIALOG' as const;

export type SetShowMisconfiguredDialogAction = {
	type: typeof SET_SHOW_MISCONFIGURED_DIALOG;
	payload: {
		show: boolean;
	};
};

export const setShowMisconfiguredDialog = (show: boolean): SetShowMisconfiguredDialogAction => ({
	type: SET_SHOW_MISCONFIGURED_DIALOG,
	payload: {
		show,
	},
});

// SAVE_RUN_AS_USER
export const SAVE_RUN_AS_USER = 'state.actions.run-as-user.SAVE_RUN_AS_USER' as const;

export type SaveRunAsUserAction = {
	type: typeof SAVE_RUN_AS_USER;
	payload: {
		accountId: string;
		event?: UIAnalyticsEvent;
	};
};

export const saveRunAsUser = (
	accountId: string,
	event?: UIAnalyticsEvent,
): SaveRunAsUserAction => ({
	type: SAVE_RUN_AS_USER,
	payload: {
		accountId,
		event,
	},
});

// SAVE_RUN_AS_USER_SUCCESS
export const SAVE_RUN_AS_USER_SUCCESS =
	'state.actions.run-as-user.SAVE_RUN_AS_USER_SUCCESS' as const;

export type SaveRunAsUserSuccessAction = {
	type: typeof SAVE_RUN_AS_USER_SUCCESS;
	payload: {
		runAsUserSettings: SummaryRunAsUserSettings;
	};
};

export const saveRunAsUserSuccess = (
	runAsUserSettings: SummaryRunAsUserSettings,
): SaveRunAsUserSuccessAction => ({
	type: SAVE_RUN_AS_USER_SUCCESS,
	payload: {
		runAsUserSettings,
	},
});

// SAVE_RUN_AS_USER_FAILURE
export const SAVE_RUN_AS_USER_FAILURE =
	'state.actions.run-as-user.SAVE_RUN_AS_USER_FAILURE' as const;

export type SaveRunAsUserFailureAction = {
	type: typeof SAVE_RUN_AS_USER_FAILURE;
	payload: {
		errorMessage: string;
	};
};

export const saveRunAsUserFailure = (errorMessage: string): SaveRunAsUserFailureAction => ({
	type: SAVE_RUN_AS_USER_FAILURE,
	payload: {
		errorMessage,
	},
});
